import { AlertListTypeEnum, StrategyTypes } from '../../../../utilities/Constants';

import Authorization from '../../../../stores/Authorization';
import { CheckmateEasyUpdateIcon } from '../../../../shared/CheckmateIcons';
import { DataMenuItem } from './DataMenuItem';
import { IOrganizationRoleModel } from '../../../../interfaces/IUser';
import { LocalRoutes } from '../../../../utilities/LocalRoutes';
import { MenuItemNavLinkWithIcon } from '../../MenuItemNavLinkWithIcon';
import { Stack } from 'react-bootstrap';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useZoneContext } from '../../../../contexts/useZoneContext';

interface INavigationMenuProps {
    onZoneChange: (org: IOrganizationRoleModel, redirectPath?: string) => void;
}

export function NavigationMenu(props: INavigationMenuProps) {
    const { user, isLoggedIn } = useAuthContext();
    const { buildZoneUrl, zoneGuid } = useZoneContext();

    if (!user.profile) {
        return <div className="float-end" style={{ margin: '38px' }} />;
    }

    const showCaseMenuItem =
        Authorization.isAuthorizedToRoute(LocalRoutes.Cases, user, zoneGuid) ||
        Authorization.isAuthorizedToRoute(LocalRoutes.CaseEasyUpdate, user, zoneGuid) ||
        Authorization.isAuthorizedToRoute(LocalRoutes.PackageSettlements, user, zoneGuid);

    return (
        <Stack direction="horizontal" style={{ gap: '4vw' }}>
            {showCaseMenuItem && (
                <div className="innerContainer">
                    <button
                        className="btn-black bold"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        CASES
                    </button>
                    <div className="dropdown-menu adjust-left">
                        {isLoggedIn && (
                            <div>
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.Cases,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-list"
                                        label="CASE LIST"
                                        to={`${buildZoneUrl(LocalRoutes.Cases)}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.CaseEasyUpdate,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon={<CheckmateEasyUpdateIcon />}
                                        label="EASY UPDATE"
                                        to={`${buildZoneUrl(
                                            LocalRoutes.CaseEasyUpdate.replace(':guid', '')
                                        )}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.PackageSettlements,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-box-usd"
                                        label="PACKAGE DEALS"
                                        to={`${buildZoneUrl(LocalRoutes.PackageSettlements)}`}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <DataMenuItem onZoneChange={props.onZoneChange} />
            {Authorization.showStrategyMenuItem(user, zoneGuid) && (
                <div className="innerContainer">
                    <button className="btn-black bold" data-bs-toggle="dropdown">
                        STRATEGY
                    </button>
                    <div className="dropdown-menu adjust-left">
                        {isLoggedIn ? (
                            <div>
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.StrategicPlan,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-flag"
                                        label="STRATEGIC PLAN"
                                        to={`${buildZoneUrl(LocalRoutes.StrategicPlan)}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.StrategyExecutionPlan,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-users"
                                        label="EXECUTION PLAN"
                                        to={`${buildZoneUrl(LocalRoutes.StrategyExecutionPlan)}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToStrategyType(
                                    StrategyTypes.PlaintiffsFirm.Name,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-building"
                                        label="PLAINTIFFS FIRMS"
                                        to={`${buildZoneUrl(
                                            LocalRoutes.Strategy.replace(
                                                ':type',
                                                StrategyTypes.PlaintiffsFirm.Value.toString()
                                            )
                                        )}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToStrategyType(
                                    StrategyTypes.Jurisdiction.Name,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-gavel"
                                        label="JURISDICTIONS"
                                        to={`${buildZoneUrl(
                                            LocalRoutes.Strategy.replace(
                                                ':type',
                                                StrategyTypes.Jurisdiction.Value.toString()
                                            )
                                        )}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToStrategyType(
                                    StrategyTypes.Projects.Name,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-chart-gantt"
                                        label="PROJECTS"
                                        to={`${buildZoneUrl(LocalRoutes.Projects)}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToStrategyType(
                                    StrategyTypes.LocalCounsel.Name,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-map-marker-smile"
                                        label="LOCAL COUNSEL"
                                        to={`${buildZoneUrl(
                                            LocalRoutes.Strategy.replace(
                                                ':type',
                                                StrategyTypes.LocalCounsel.Value.toString()
                                            )
                                        )}`}
                                    />
                                )}
                                {Authorization.isAuthorizedToStrategyType(
                                    StrategyTypes.Experts.Name,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-head-side-brain"
                                        label="EXPERTS"
                                        to={`${buildZoneUrl(LocalRoutes.Experts)}`}
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>
                </div>
            )}

            {isLoggedIn && Authorization.showReviewMenuItem(user, zoneGuid) && (
                <div className="innerContainer">
                    <button className="btn-black bold" data-bs-toggle="dropdown">
                        REVIEW
                    </button>
                    <div className="dropdown-menu adjust-left">
                        {Authorization.isAuthorizedToRoute(LocalRoutes.Alerts, user, zoneGuid) && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-bell-exclamation"
                                label="MY ALERT LIST"
                                to={`${buildZoneUrl(
                                    LocalRoutes.Alerts.replace(
                                        ':type',
                                        AlertListTypeEnum.MyAlertList.toString()
                                    )
                                )}`}
                            />
                        )}
                        {Authorization.isAuthorizedToRoute(LocalRoutes.Alerts, user, zoneGuid) && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-bells"
                                label="ZONE ALERT LIST"
                                to={`${buildZoneUrl(
                                    LocalRoutes.Alerts.replace(
                                        ':type',
                                        AlertListTypeEnum.ZoneAlertList.toString()
                                    )
                                )}`}
                            />
                        )}
                        {Authorization.isAuthorizedToRoute(LocalRoutes.Trends, user, zoneGuid) && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-chart-line-down"
                                label="TRENDS"
                                to={`${buildZoneUrl(LocalRoutes.Trends)}`}
                            />
                        )}
                        {Authorization.isAuthorizedToRoute(
                            LocalRoutes.Snapshot,
                            user,
                            zoneGuid
                        ) && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-camera-retro"
                                label="SNAPSHOT"
                                to={`${buildZoneUrl(LocalRoutes.Snapshot)}`}
                            />
                        )}
                        {Authorization.isAuthorizedToRoute(LocalRoutes.Board, user, zoneGuid) && (
                            <MenuItemNavLinkWithIcon
                                icon="fal fa-game-board"
                                label="BOARD"
                                to={`${buildZoneUrl(LocalRoutes.Board)}`}
                            />
                        )}
                    </div>
                </div>
            )}
        </Stack>
    );
}
